import { createContext } from "react";

export const AuthorizedWidgetsContext = createContext([]);
